
import React, { useState, useEffect } from 'react';
import { Monitor, Download, X, Sparkles } from 'lucide-react';

interface Props {
  t: any;
}

const InstallPrompt: React.FC<Props> = ({ t }) => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Only show if not already installed
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
      if (!isStandalone) {
          setShowPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-24 md:bottom-8 left-4 right-4 md:left-auto md:right-8 md:w-80 z-50 animate-slide-up">
        <div className="bg-slate-900 text-white p-6 rounded-[2rem] shadow-2xl border border-white/10 relative overflow-hidden group">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:scale-125 transition-transform">
                <Monitor className="w-20 h-20" />
            </div>
            <button onClick={() => setShowPrompt(false)} className="absolute top-4 left-4 text-white/40 hover:text-white">
                <X className="w-4 h-4" />
            </button>
            
            <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-primary-500 rounded-xl">
                    <Download className="w-5 h-5" />
                </div>
                <h4 className="font-bold text-sm">{t.install_title}</h4>
            </div>
            
            <p className="text-xs text-slate-400 mb-6 leading-relaxed">
                {t.install_desc}
            </p>
            
            <button 
                onClick={handleInstall}
                className="w-full bg-white text-slate-900 py-3 rounded-xl font-bold text-sm hover:bg-primary-50 transition-colors flex items-center justify-center gap-2"
            >
                <Sparkles className="w-4 h-4 text-primary-500" />
                {t.install_btn}
            </button>
        </div>
    </div>
  );
};

export default InstallPrompt;
